import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';
import { isAuthenticatedSelector } from './isAuthenticated';

const credentialsSelector = createSelector(
  [isAuthenticatedSelector, propertiesSelector],
  (isAuthenticated, { accessToken }) =>
    isAuthenticated && {
      Authorization: `Bearer ${accessToken}`,
    },
);

export const userAccountCredentialsSelector = subselect(credentialsSelector);
